import { Injectable } from "@angular/core";
import {Observable} from "rxjs/Observable";
import {JobType} from "./job-type.model";
import {environment} from "../../../app/config/environment";
import {MyHttp} from "../../../app/core/http";

@Injectable()
export class JobTypeService {

  constructor(private http: MyHttp) {}

  getJobTypes(): Observable<JobType[]> {
    return this.http.get(environment.API + '/job_types')
      .map(res => res.json());
  }
}



// WEBPACK FOOTER //
// ./src/pages/shared/job-type/job-type.service.ts